import React from "react";
import dayjs from "dayjs";
import { PencilSimpleIcon, CopyIcon, TrashIcon } from "@phosphor-icons/react";
import CustomTag from "../../../ui/CustomTag";
import { formatDuration } from "../utils/trackingUtils";

const TimeTableViewRow = ({ entry, projects, onEdit, onDuplicate, onDelete }) => {
    const project = projects.find((p) => p.id === entry.task?.section?.projectId);

    return (
        <>
            <td className="entry-line-date editable" onClick={() => onEdit(entry.id)}>
                <CustomTag className="default" value={dayjs(entry.date).format("DD/MM/YYYY")} />
            </td>
            <td className="entry-line-project" onClick={() => onEdit(entry.id)}>
                <span>{project?.name || ""}</span>
            </td>
            <td className="entry-line-task" onClick={() => onEdit(entry.id)}>
                <CustomTag value={entry.task?.name || ""} />
            </td>
            <td className="entry-line-comments" onClick={() => onEdit(entry.id)}>
                <span className="comments">{entry.comments}</span>
            </td>
            <td className="entry-line-duration" onClick={() => onEdit(entry.id)}>
                <CustomTag className="default" value={formatDuration(entry.duration)} />
            </td>
            <td className="entry-line-actions">
                <div className="action-buttons-container">
                    <button className="action-button modifier-button" onClick={() => onEdit(entry.id)} title="Modifier">
                        <PencilSimpleIcon size={16} weight="bold" />
                    </button>
                    <button className="action-button duplicate-button" onClick={() => onDuplicate(entry)} title="Dupliquer">
                        <CopyIcon size={16} weight="bold" />
                    </button>
                    <button className="action-button delete-button" onClick={() => onDelete(entry)} title="Supprimer">
                        <TrashIcon size={16} weight="bold" />
                    </button>
                </div>
            </td>
        </>
    );
};

export default React.memo(TimeTableViewRow);
